import List from './List';
import Item, { TreeItem, ItemWithButton, ItemWithDelete } from './Item';

// There is constant warning about Droppable: unsupported nested scroll container detected.
// It happens because <main> has overflow-x: hidden style which is set by Antd
// I assume that this warning can be safely ignored

const Sortable = () => {
  throw new Error('<Sortable> is not meant to be used as a component. Use <Sortable.List> or <Sortable.Item>');
};

Sortable.List = List;
Sortable.Item = Item;
Sortable.TreeItem = TreeItem;
Sortable.ItemWithButton = ItemWithButton;
Sortable.ItemWithDelete = ItemWithDelete;

export default Sortable;
